var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 135,
    viewBox: "0 0 123 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123 67.5L0 134.617L0 0.383034L123 67.5Z",
    fill: "#121415"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94 67L14.5 110.301L14.5 23.6987L94 67Z",
    fill: "#E2DFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightButton);
export default __webpack_public_path__ + "static/media/right-button.64c0fd9066deda8754b66eb64850acdb.svg";
export { ForwardRef as ReactComponent };